export default "__VITE_ASSET__DNh8U5C6__"